import request from '@/utils/request'
import { getToken, isEmulation } from '@/utils/auth'


export function getList (entity, filters = {}, pagination = {}) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

export function getCount (entity, filters = {}) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1 })
    }
  }).then(ret => ret.tot)
}



export function getDetail (entity, item, headers) {
  return request({
    url: '/' + entity + (item && item.id ? '/' + item.id  : ''),
    method: 'get',
    headers
  })
}


export function get (url) {
  return request({
    url,
    method: 'get',
  })
}

export function post (url, data, headers = {}) {
  request.defaults.timeout = 100000;
  return request({
    url,
    method: 'post',
    data,
    headers
  })
}


export function put (entity, id, data, headers = {}) {
  const method = 'put'
  const url = '/' + entity + '/' + id
  return request({
    url,
    method,
    data,
    headers
  })
}

export function upsert (entity, data) {
  request.defaults.timeout = 50000;
  let method = 'post'
  let url = '/' + entity
  if (data.id) {
    method = 'put'
    url = '/' + entity + '/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (entity, item) {
  return request({
    url: '/' + entity + '/' + item.id,
    method: 'delete'
  })
}



export function download(path, file = 'file') {

  return fetch(
    process.env.VUE_APP_BASE_API + `/${path}`,
    {
      headers: {
        Authorization: 'Bearer ' + getToken(),
        isEmulation: isEmulation() || ''
      },
      responseType: 'blob'     
    }
  )
  .then( response => {
    
    const filename = response.headers.get("X-Filename") || file

    response.blob().then( blob => {
      var fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    })
  })
  
}


export function uploadPdf (data, type) {

  request.defaults.timeout = 20000;
  const promise = request({
    url: '/pdf/upload/' + type,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  promise.finally( () => { request.defaults.timeout = 5000;})
  return promise;
}


export function downloadPdf (id, type, filename, download = true) {
  return request({
    url: '/pdf/' + type + '/' + id,
    method: 'get',
    responseType: 'blob',
  }).then( response => {

      var newBlob = new Blob([response], {type: "application/pdf"});
      var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
      
      if(download) {
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
      }

      return fileURL
      // let tab = window.open(); 
      // tab.location.href = fileURL;

  })
}